import { render } from "./ProductMobile.vue?vue&type=template&id=4f970677&scoped=true"
import script from "./ProductMobile.vue?vue&type=script&lang=js"
export * from "./ProductMobile.vue?vue&type=script&lang=js"

import "./ProductMobile.vue?vue&type=style&index=0&id=4f970677&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f970677"]])

export default __exports__